export var wargameExerciseStatuses = {
    todo: {
        name: "TODO",
        label: "To do"
    },
    brainstormAndWalkthrough: {
        name: "BRAINSTORM AND WALKTHROUGH",
        label: "Brainstorm and Walkthrough"
    },
    prepareExperiments: {
        name: "PREPARE EXPERIMENT",
        label: "Prepare Experiments"
    },
    executeExperiments: {
        name: "EXECUTE EXPERIMENTS",
        label: "Execute Experiments"
    },
    done: {
        name: "DONE",
        label: "Done"
    },
    cancelled: {
        name: "CANCELLED",
        label: "Cancelled"
    }
};
